/** A person as GET /activity returns them: a staff member or a member. */
export interface ActivityPerson {
  id: string
  first_name: string | null
  last_name: string | null
  nickname: string | null
  email: string | null
  avatar_ext: string | null
  avatar_updated_at: string | null
}

export interface ActivityEntry {
  id: string
  created_at: string
  actor_user_id: string
  action: string
  entity_type: string
  entity_id: string | null
  member_user_id: string | null
  child_id: string | null
  /** `{field: [before, after]}`, only the fields that changed. */
  changes: Record<string, [unknown, unknown]>
  actor: ActivityPerson | null
  member: ActivityPerson | null
  child: { id: string; first_name: string | null; last_name: string | null } | null
}

export interface ActivityPage {
  entries: ActivityEntry[]
  plan_names: Record<string, string>
  /** Entries across every page, for the page numbers. */
  total: number
  has_more: boolean
}

export interface ActivityPeople {
  actors: ActivityPerson[]
  members: ActivityPerson[]
}

/** One tab per kind of action. Matches ACTIVITY_TYPES in the Worker. */
export const ACTIVITY_TABS = [
  'all',
  'sales',
  'transfers',
  'edits',
  'cancellations',
  'freezes',
  'invoices',
] as const
export type ActivityTab = (typeof ACTIVITY_TABS)[number]

/** What the "what changed" filter offers. Matches FILTERABLE_FIELDS in the Worker. */
export const CHANGE_FIELDS = [
  'starts_at',
  'expires_at',
  'entries_remaining',
  'price_paid',
  'gym_plan_id',
  'status',
] as const

/** A person's name, or their email when the profile has none. */
export function personName(person: ActivityPerson | null, fallback: string): string {
  if (!person) return fallback
  const name = [person.first_name, person.last_name].filter(Boolean).join(' ').trim()
  return name || person.email || fallback
}
